<div class="trial">
    <span class="trial__icon material-symbols-outlined icon-md" aria-hidden="true">hourglass_top</span>
    <p class="trial__text" [innerHTML]="'menu.pricingPlan.text' | translate: { days: daysLeft }"></p>
    <p-button [label]="'menu.pricingPlan.button' | translate" size="small" [fluid]="true" (onClick)="contact.emit()" />
</div>
